<template lang="pug">
el-dialog(
  :visible.sync="modalAberto",
  width="880px",
  center,
  :close-on-click-modal="false",
  custom-class="modal-pacientes",
  top="10vh",
  @close="close"
)
  span(slot="title")
    .titulo Paciente
    el-switch(
      v-model="status",
      active-color="#13ce66",
      inactive-color="#e4e4e4"
    )
  .corpo-modal-pacientes
    .nome
      label Nome
        span *
      el-input(
        v-model="nome",
        placeholder="Digite o nome...",
        :maxlength="100",
        :disabled="edicao ? true : false"
      )
      .validacao(v-if="validacaoNome") Nome Obrigatório!
    .info-primary
      .tipoDocumento
        label Tipo Documento
        el-select(v-model="idDocumentoTipo", placeholder="Selecione...")
          el-option(
            v-for="item in tipoDocumento",
            :key="item.id",
            :label="item.sigla",
            :value="item.id"
          )
      .cpf
        label Número Documento
        el-input(v-model="cpf", placeholder="Digite o número do Documento...")
      .nascimento
        label Data Nascimento
          span *
        el-input(
          v-model="nascimento",
          placeholder="01/01/2000",
          v-mask="'##/##/####'",
          :disabled="edicao ? true : false"
        )
        .validacao(v-if="validacaoNascimento") Data de Nascimento Obrigatória!
      .genero
        label Gênero
        el-select(v-model="valorGenero", placeholder="Selecione...")
          el-option(
            v-for="item in genero",
            :key="item.value",
            :label="item.label",
            :value="item.value"
          )
    .info-second
      .email
        label Email
        el-input(
          v-model="email",
          placeholder="Digite o email...",
          :maxlength="100"
        )
      .cel
        label Celular
        el-input(
          v-model="celular",
          placeholder="Digite o celular...",
          v-mask="['(##) ####-####', '(##) #####-####']"
        )
  span.dialog-footer(slot="footer")
    span(v-show="novoCadastro")
      el-button.novo-cadastro(
        type="primary",
        @click="salvar",
        :loading="loadBtn"
      ) Salvar e Enviar Senha
    span(v-show="!novoCadastro")
      el-button(@click="reenviarSenha", :loading="loadBtn") Reenviar senha
      el-button(type="primary", @click="salvar", :loading="loadBtn") Salvar
</template>

<script>
import Services from "../../utils/services";
import moment from "moment";
moment.locale("pt-BR");

export default {
  props: ["openModal", "edicao"],

  data: () => ({
    modalAberto: false,
    novoCadastro: true,
    loadBtn: false,
    nome: "",
    tipoDocumento: [],
    idDocumentoTipo: "",
    cpf: "",
    nascimento: "",
    valorGenero: "",
    email: "",
    celular: "",
    status: true,
    genero: [
      {
        value: "M",
        label: "Masculino",
      },
      {
        value: "F",
        label: "Feminino",
      },
    ],
    validacaoNome: false,
    validacaoNascimento: false,
  }),

  computed: {},

  watch: {
    openModal() {
      if (this.openModal) {
        this.modalAberto = true;
        this.buscaTipoDocumento();
        if (this.edicao) {
          console.log(this.edicao);
          let e = this.edicao;
          this.status = e.status === "A" ? true : false;
          this.nome = e.nome;
          this.cpf = e.cpf || e.documento;
          this.nascimento = moment(e.data_nascimento).format("L");
          this.valorGenero = e.genero;
          this.email = e.email;
          this.celular = e.telefone.replace(
            /(\d{2})(\d{5})(\d{4})/,
            "($1) $2-$3"
          );
          this.novoCadastro = false;
          this.idDocumentoTipo = !e.id_documento_tipo
            ? 3
            : Number(e.id_documento_tipo);
        }
      } else this.modalAberto = false;
    },
  },

  methods: {
    close() {
      this.$emit("close", true);
      this.limpaVariaveis();
    },
    async reenviarSenha() {
      this.loadBtn = true;
      let doc = "";
      if (this.cpf.length == 14) {
        doc = this.cpf.replace(".", "").replace(".", "").replace("-", "");
      } else doc = this.cpf;
      let resp = await Services.get(`/paciente/${doc}/senha/reenviar`).catch(
        (e) => {
          this.$message({
            message: e.response.data,
            type: "error",
            duration: 4000,
          });
          this.loadBtn = false;
        }
      );
      if (resp) {
        this.loadBtn = false;
        this.$message({
          message: "Senha reenviada, paciente deve verificar o email!",
          type: "success",
          duration: 4000,
        });
      }
    },

    /* Metodo que busca os tipo de documentos */
    async buscaTipoDocumento() {
      this.tipoDocumento = await Services.get("/documentos/tipos");
      console.log("tipo documento", this.tipoDocumento);
    },

    /* Método que salva e edita o cadastro de Pacientes */
    async salvar() {
      if (this.nome.length > 3 && this.nascimento) {
        (this.validacaoNome = false), (this.validacaoNascimento = false);
        this.loadBtn = true;
        let data = JSON.stringify({
          nome: this.nome.normalize("NFD").replace(/[\u0300-\u036f]/g, ""),
          cpf: "",
          documento: this.cpf,
          idDocumentoTipo: this.idDocumentoTipo.toString(),
          dataNascimento: this.nascimento.split("/").reverse().join("-"),
          genero: this.valorGenero,
          email: this.email,
          status: this.status ? "A" : "I",
          telefone: this.celular,
        });
        if (this.edicao) {
          /* Condição que edita o cadastro dos pacientes */
          let editar = await Services.put(
            `/paciente/${this.edicao.id}`,
            data
          ).catch(() => {
            this.loadBtn = false;
            this.$message({
              message: "Houve um erro ao salvar, tente novamente.",
              type: "error",
              duration: 3000,
            });
          });
          if (editar) {
            this.loadBtn = false;
            this.$message({
              message: "Edição realizada com sucesso!",
              type: "success",
              duration: 3000,
            });
            setTimeout(() => {
              this.close();
              this.limpaVariaveis();
              this.$emit("atualiza", true);
            }, 2000);
          }
        } else {
          /* Condição que efetua o cadastro de um novo paciente */
          let salvar = await Services.post("/paciente", data).catch(() => {
            this.loadBtn = false;
            this.$message({
              message: "Houve um erro ao salvar, tente novamente.",
              type: "error",
              duration: 3000,
            });
          });
          if (salvar) {
            this.loadBtn = false;
            this.$message({
              message: "Cadastro realizado com sucesso!",
              type: "success",
              duration: 2000,
            });
            setTimeout(() => {
              this.close();
              this.limpaVariaveis();
              this.$emit("atualiza", true);
            }, 2000);
          }
        }
      } else {
        if (this.nome.length < 3) this.validacaoNome = true;
        else this.validacaoNome = false;
        if (!this.dataNascimento) this.validacaoNascimento = true;
        else this.validacaoNascimento = false;
      }
    },

    /* Metodo que limpa os campos */
    limpaVariaveis() {
      this.nome = "";
      this.cpf = "";
      this.idDocumentoTipo = "";
      this.nascimento = "";
      this.valorGenero = "";
      this.email = "";
      this.celular = "";
      this.status = true;
      (this.validacaoNome = false), (this.validacaoNascimento = false);
    },

    /* Metodo que verifica se o CPF digitado é um cpf valido */
    TestaCPF(strCPF) {
      let cpf = strCPF.replace(/[^\d]+/g, "");
      let Soma;
      let Resto;
      let i;
      Soma = 0;
      if (cpf == "00000000000") return (this.cpfInvalido = true);
      for (i = 1; i <= 9; i++)
        Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
      Resto = (Soma * 10) % 11;
      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(cpf.substring(9, 10)))
        return (this.cpfInvalido = true);
      Soma = 0;
      for (i = 1; i <= 10; i++)
        Soma = Soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
      Resto = (Soma * 10) % 11;
      if (Resto == 10 || Resto == 11) Resto = 0;
      if (Resto != parseInt(cpf.substring(10, 11)))
        return (this.cpfInvalido = true);
      return (this.cpfInvalido = false);
    },
  },
};
</script>

<style lang="scss">
.modal-pacientes {
  border-radius: 20px;

  .el-dialog__header {
    padding-top: 50px;

    span {
      display: flex;
      align-items: center;
      justify-content: center;

      .titulo {
        font-size: 32px;
        color: #000;
        font-weight: 100;
      }

      .el-switch {
        margin-left: 20px;

        .el-switch__core {
          width: 45px !important;
          height: 25px;
          border-radius: 20px;

          &::after {
            width: 21px;
            height: 21px;
          }
        }

        &.is-checked {
          .el-switch__core {
            &::after {
              margin-left: -25px;
            }
          }
        }
      }
    }
    button.el-dialog__headerbtn {
      top: 50px;

      i {
        font-size: 33px;
      }
    }
  }

  .el-dialog__body {
    .corpo-modal-pacientes {
      padding: 45px;
      box-sizing: border-box;

      label {
        font-size: 17px;
        color: #0180ff;
        font-weight: 400;

        span {
          margin-left: 3px;
          color: red;
        }
      }
      .el-input {
        input {
          border-right: none;
          border-top: none;
          border-left: none;
          border-radius: 0;
          padding-left: 0;
          font-size: 22px;
          color: #000;
          font-weight: 300;
        }
      }

      .nome,
      .nascimento {
        position: relative;

        .validacao {
          position: absolute;
          font-size: 12px;
          bottom: -17px;
          color: red;
        }
      }

      .info-primary {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 40px;
        flex-wrap: wrap;

        .tipoDocumento,
        .cpf,
        .nascimento,
        .genero {
          width: 350px;

          .el-select {
            width: 100%;
          }
        }
        .nascimento,
        .genero {
          margin-top: 40px;
        }
        .cpf {
          position: relative;

          &.erro {
            input {
              color: red;
              border-color: red;
            }
          }

          span {
            color: #f56c6c;
            font-size: 12px;
            font-weight: 400;
            position: absolute;
            left: 0;
            bottom: -21px;
            background: #fff;
            height: 21px;
            line-height: 1.8;
            z-index: 1;
          }
        }
      }
      .info-second {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 40px;

        .email {
          width: 455px;
        }
        .cel {
          width: 200px;
        }
      }
    }
  }

  .el-dialog__footer {
    padding-bottom: 50px;
    padding-top: 0;

    .el-button {
      width: 210px;
      height: 60px;
      font-size: 22px;
      border-radius: 8px;
      font-weight: 300;

      &.novo-cadastro {
        width: 270px;
      }
    }
  }
}
</style>